<template>
  <banner-section :wrapper-form-button-text="homePageTitle">
    <template slot="left-wrapper">
      <cac-page-header
        slot="header"
        :title="homePageTitle"
      />

      <div
        v-if="!hasAdvocate"
        class="registration-buttons d-flex">
        <button
          :class="isSelectedOption(homeButtonLabels.YES)"
          class="btn btn--small col"
          type="button"
          @click.prevent="changeRegistrationOption(homeButtonLabels.YES)"
        >{{ $t('cac.app.yes') }}</button>
        <button
          :class="isSelectedOption(homeButtonLabels.NO)"
          class="btn btn--small col ml-md-3"
          type="button"
          @click.prevent="changeRegistrationOption(homeButtonLabels.NO)"
        >{{ $t('cac.app.no') }}</button>
        <button
          :class="isSelectedOption(homeButtonLabels.NOT_SURE)"
          class="btn btn--small col ml-md-3"
          type="button"
          @click.prevent="changeRegistrationOption(homeButtonLabels.NOT_SURE)"
        >{{ $t('cac.app.not_sure') }}</button>
      </div>
      <div
        v-else
        class="d-flex flex-column align-items-md-start">
        <span class="page-section--banner__subtitle">{{ $t('cac.app.learn_more_about_candidates') }}</span>
        <router-link
          :to="{name: RouteNames.CANDIDATES}"
          class="btn btn--primary mt-4 candidates-btn">
          {{ $t('cac.app.find_my_candidates') }}
        </router-link>
      </div>
    </template>
    <template slot="right-wrapper">
      <div
        class="col-md-8 offset-md-1">
        <span
          v-if="!hasAdvocate"
          class="cac-personal-information__help-text mt-3 mt-md-0 d-block d-none">{{ $t('cac.app.provide_state_issued_information') }}</span>
        <div
          v-if="errorMessage"
          class="banner">
          <span>{{ errorMessage }}</span>
        </div>
        <personal-information
          :key="pageKey"
          :selected-registration-option="selectedRegistrationOption"
        />
      </div>
    </template>
  </banner-section>
</template>

<script>
import { mapGetters } from "vuex";
import STATE from "Constants/campaign/civicactioncenter/state";
import BannerSection from "CivicActionCenterComponents/shared/BannerSection.vue";
import PersonalInformation from "CivicActionCenterComponents/shared/PersonalInformation.vue";
import * as HOME_BUTTON_LABELS from "Constants/campaign/civicactioncenter/homeButtonLabels";
import CacPageHeader from "CivicActionCenterComponents/layout/CACPageHeader.vue";
import RouteNames from "Constants/campaign/civicactioncenter/routeNames";

import SharedMixin from "JS/mixins/campaign/civicactioncenter/shared";

const formErrorContext = `${STATE.SCOPE_FORMS}/${STATE.ERROR}`;
const hasAdvocateContext = `${STATE.SCOPE_CAC}/${STATE.HAS_ADVOCATE}`;

export default {
  name: "WelcomeBanner",
  components: {
    BannerSection,
    PersonalInformation,
    CacPageHeader
  },
  mixins: [SharedMixin],
  props: {
    pageKey: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      homeButtonLabels: HOME_BUTTON_LABELS,
      selectedRegistrationOption: "No",
      RouteNames
    };
  },
  computed: {
    ...mapGetters({
      errorMessage: formErrorContext,
      hasAdvocate: hasAdvocateContext
    }),
    homePageTitle() {
      if (this.hasAdvocate) {
        return this.$t("cac.app.find_your_candidates");
      }
      return `${this.$t("cac.app.welcome")}\n${this.$t(
        "cac.app.registered_to_vote"
      )}`;
    }
  },
  methods: {
    changeRegistrationOption(option) {
      this.selectedRegistrationOption = option;
      this.trackMixpanelInteract();
    },
    isSelectedOption(option) {
      return option === this.selectedRegistrationOption
        ? "btn--primary"
        : "btn--secondary";
    }
  }
};
</script>
